const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://4xes4rgxlb.execute-api.eu-west-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://tn00uz2b1d.execute-api.eu-west-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.macquarie.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.macquarie.forwoodsafety.com'
  }
};

export default config;